export default "/images/why_work_with_us/cybersec_lock.png";